import type { SorterResult } from "antd/lib/table/interface";
import { type ExtendedColumnsType, GenericTable, type ResourceTableProps } from "components";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";
import type { ValidationReport } from "../../../types/entities/validationReport";

export const ValidationReportsTable: FC<ResourceTableProps<ValidationReport>> = ({ onStateChanged, onRowSelectionChange, datasource }) => {
    const { t } = useTranslation();
    const getColumnsConfig = useCallback(
        (sortInfo: SorterResult<ValidationReport>): ExtendedColumnsType<ValidationReport>[] => {
            return [
                {
                    title: t("validationReports.id"),
                    dataIndex: "id",
                    key: "id",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "id" ? sortInfo.order : null,
                },
                {
                    title: t("validationReports.validationSubjectType"),
                    dataIndex: "type",
                    key: "type",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "type" ? sortInfo.order : null,
                },
                {
                    title: t("validationReports.subject"),
                    dataIndex: "subject",
                    key: "subject",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "subject" ? sortInfo.order : null,
                },
                {
                    title: t("validationReports.validatedOn"),
                    dataIndex: "validatedOn",
                    key: "validatedOn",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "validatedOn" ? sortInfo.order : null,
                },
                {
                    title: t("validationReports.validationErrors"),
                    dataIndex: "validationErrors",
                    key: "validationErrors",
                },
            ];
        },
        [t],
    );

    const navigate = useNavigate();
    const onRowClick = (record: ValidationReport) =>
        navigate(`${BASE_PATH}/${ResourceName.SITE_GROUPS}/${FORM_ACTION.EDIT}/${record.id}?id=${record.id}`);

    return (
        (datasource && (
            <GenericTable<ValidationReport>
                getColumnsConfig={getColumnsConfig}
                datasource={datasource}
                onSelectionCallback={onRowSelectionChange}
                onStateChanged={onStateChanged}
                onRow={(record: ValidationReport) => {
                    return {
                        onClick: () => onRowClick(record),
                    };
                }}
            />
        )) ||
        null
    );
};
